import { render } from "./CalendarR.vue?vue&type=template&id=4878dad4&scoped=true"
import script from "./CalendarR.vue?vue&type=script&lang=js"
export * from "./CalendarR.vue?vue&type=script&lang=js"

import "./CalendarR.vue?vue&type=style&index=0&id=4878dad4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4878dad4"],['__file',"src/components/CalendarR.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4878dad4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4878dad4', __exports__)) {
    api.reload('4878dad4', __exports__)
  }
  
  module.hot.accept("./CalendarR.vue?vue&type=template&id=4878dad4&scoped=true", () => {
    api.rerender('4878dad4', render)
  })

}


export default __exports__